/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AssessmentRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let person = this.modelFor('people.person').person;
    let pageModel = this.modelFor('people.person.page');
    let page = pageModel.page;
    let assessments = page.assessment_ids;
    // assessments is a fragment array: spread it, or stringify reaches the store.
    let assessmentIds = JSON.stringify([...assessments]);

    return hash({
      assessment: store.findRecord(
        'assessments/assessment',
        params.assessment_id,
      ),
      modules: store.query('assessments/module', {
        assessmentIds,
        include: 'gradeSchedules',
      }),
      person,
      grades: store.query('assessments/grade', {
        assessmentId: params.assessment_id,
        personId: person.id,
      }),

      page,

      assessmentPosts: this.store.query('posts/post', {
        assessmentId: params.assessment_id,
        pageId: page.id,
        personId: person.id,
        include: 'reactions,comments',
      }),
      posts: this.store.query('posts/post', {
        personId: person.id,
        pageId: page.id,
        include: 'reactions,comments',
      }),
    });
  }
}
